<template>
  <div
    v-if="isMobileScreenSize"
    class="fixed top-0 left-0 w-screen h-full table bg-black-50 z-10"
  >
    <div id="outside" class="table-cell align-bottom">
      <div
        ref="modalContents"
        class="modal-container rounded-lg m-auto bg-white"
        role="dialog"
        aria-modal="true"
        aria-label="Confirm"
      >
        <div
          class="flex flex-col rounded-t px-16 justify-between items-center py-24 gap-32 w-screen"
        >
          <div class="flex flex-col gap-16 w-full">
            <H2 class="font-bold mt-8 self-center">
              {{ $t('health_actions.scheduling.select_doctor_search_doctors') }}
            </H2>
            <Body class="text-grey-500 font-semibold">
              {{ $t('health_actions.scheduling.select_doctor_distance') }}
            </Body>
            <div class="flex border border-grey-300 rounded p-16">
              <select
                class="w-full justify-between bg-white"
                @change="
                  (e) => setDoctorPreferences({ distance: e.target.value })
                "
              >
                <option value="">
                  {{ $t('common.select') }}
                </option>
                <option
                  v-for="option in distanceOptions"
                  :key="option.value"
                  :value="option.value"
                  :selected="option.value === getDoctorPreferences.distance"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="flex flex-col gap-8 flex-1">
              <Body class="text-grey-500 font-semibold">
                {{ $t('health_actions.scheduling.select_doctor_gender') }}
              </Body>
              <div class="flex border border-grey-300 rounded p-16">
                <select
                  class="w-full justify-between bg-white"
                  @change="
                    (e) => setDoctorPreferences({ gender: e.target.value })
                  "
                >
                  <option value="">
                    {{ $t('common.select') }}
                  </option>
                  <option
                    v-for="option in genderOptions"
                    :key="option.value"
                    :value="option.value"
                    :selected="option.value === getDoctorPreferences.gender"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="flex flex-col items-center gap-16 w-full">
            <HMButton rounded="full" class="w-full" @click="searchDoctors">
              {{ $t('common.search') }}
            </HMButton>
            <HMButton
              rounded="full"
              outlined
              class="w-full button--white-outlined"
              @click="$emit('close-doctor-preference-modal')"
            >
              {{ $t('common.cancel_btn') }}
            </HMButton>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-else-if="!isMobileScreenSize"
    :active="true"
    :shouldFocusFirstElement="false"
    :closeOnBackDrop="true"
    @close="$emit('close-doctor-preference-modal')"
  >
    <div
      class="flex-1 flex flex-col h-full fixed top-0 right-0 bg-white-100 bottom-0 w-435 m-0 border-0"
    >
      <div
        class="border-b border-grey-300 flex justify-between items-center p-24"
      >
        <H2 class="font-bold">
          {{ $t('health_actions.scheduling.select_doctor_search_doctors') }}
        </H2>
        <button
          class="text-grey-500"
          @click="$emit('close-doctor-preference-modal')"
        >
          <span class="text-4xl">&times;</span>
        </button>
      </div>
      <div class="p-24 flex-1">
        <div class="flex flex-col flex-grow gap-8">
          <div class="flex flex-col gap-8 flex-1">
            <Body class="text-grey-500 font-semibold">
              {{ $t('health_actions.scheduling.select_doctor_distance') }}
            </Body>
            <div class="flex border border-grey-300 rounded p-16">
              <select
                class="w-full justify-between bg-white-100"
                @change="
                  (e) => setDoctorPreferences({ distance: e.target.value })
                "
              >
                <option value="">
                  {{ $t('common.select') }}
                </option>
                <option
                  v-for="option in distanceOptions"
                  :key="option.value"
                  :value="option.value"
                  :selected="option.value === getDoctorPreferences.distance"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col gap-8 flex-1">
            <Body class="text-grey-500 font-semibold">
              {{ $t('health_actions.scheduling.select_doctor_gender') }}
            </Body>
            <div class="flex border border-grey-300 rounded p-16">
              <select
                class="w-full justify-between bg-white-100"
                @change="
                  (e) => setDoctorPreferences({ gender: e.target.value })
                "
              >
                <option value="">
                  {{ $t('common.select') }}
                </option>
                <option
                  v-for="option in genderOptions"
                  :key="option.value"
                  :value="option.value"
                  :selected="option.value === getDoctorPreferences.gender"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-full justify-between border-t border-grey-300 p-24">
        <HMButton
          rounded="full"
          outlined
          class="flex-1 button--white-outlined mr-24"
          @click="$emit('close-doctor-preference-modal')"
        >
          {{ $t('common.cancel_btn') }}
        </HMButton>
        <HMButton rounded="full" class="flex-1 " @click="searchDoctors">
          {{ $t('common.search') }}
        </HMButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '~/components/common/Modal.vue'
import H2 from '~/components/common/Typography/H2.vue'
import Body from '~/components/common/Typography/Body.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapGetters, mapActions } from 'vuex'
import doctorPreferencesMixin from './doctorPreferencesMixin'

export default {
  components: { Modal, H2, Body },
  mixins: [screenSizeMixin, doctorPreferencesMixin],
  computed: {
    ...mapGetters('scheduling', ['getDoctorPreferences', 'zipCode']),
  },
  methods: {
    ...mapActions('scheduling', ['setDoctorPreferences', 'fetchProviders']),
    searchDoctors() {
      this.fetchProviders({
        distance: this.getDoctorPreferences.distance,
        providerGender: this.getDoctorPreferences.gender,
        address: this.zipCode,
      })
      this.$emit('close-doctor-preference-modal')
    },
  },
}
</script>
